<template>
  <div :class="'container_img p-10'">
    <div class="flex justify-between">
      <div style="width:70%">
        <div class="bg-main round-sm">
          <div class="ml-15 text-bold lh-40">食堂基础信息</div>
          <div class="ml-15 py-10">
            <span>当前人数上限：{{userData.total}}人</span>
            <span class="ml-15">当前加入人数：共{{userData.used_count}}人</span>
            <span class="ml-15" v-if="userData.apply_count>0"><span style="color:#f56;">有{{userData.apply_count}}条加入申请待审核</span><span class="link-btn" @click="toUserApply">去处理</span></span>
          </div>
        </div>
        <div class="bg-main round-sm mt-15">
          <div class="flex lh-40 text-bold items-center px-15 border-b">
            <span>时段报餐统计</span>
            <span style="color:#aaa;font-weight:400;font-size:12px;">(已就餐份数/待就餐份数)</span>
            <a-tooltip>
              <template slot="title">
                <p>统计口径: 报餐份数，不包含已取消报餐。如张三提交报餐时选择3份早餐，统计为早餐3份，张三又取消了对应报餐，统计为0。</p>
              </template>
              <span class="inline-help">?</span>
            </a-tooltip>
          </div>
          <div class="ml-15 mt-10 py-15">
            <table style="width:100%;">
              <thead>
                <tr>
                  <th></th>
                  <th>昨日</th>
                  <th>今日</th>
                  <th>明日</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in recentData">
                  <td>{{ item.title }}</td>
                  <td>{{ item.data[0] }}</td>
                  <td>{{ item.data[1] }}</td>
                  <td>{{ item.data[2] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="bg-main round-sm" style="width:28%">
        <div class="flex lh-40 text-bold items-center justify-between px-15 border-b">
          <span>
            <span>月度用餐情况</span>
            <a-tooltip>
              <template slot="title">
                <p>统计口径: 报餐订单数量，如张三在一个订单里报了3份</p>
                <p>早餐，为1个订单 (包含已取消订单)</p>
                <p>已用餐:用餐状态为已用餐的订单数</p>
                <p>待用餐:用餐状态为待就餐的订单数</p>
                <p>已退餐: 用餐状态为已取消的订单数</p>
              </template>
              <span class="inline-help">?</span>
            </a-tooltip>
          </span>
          <span>
            <a-month-picker v-model:value="month" :valueFormat="monthFormat" @change="changeMonth"/>
          </span>
        </div>
        <div class="px-15" v-if="monthData && monthData.length>0">
          <p class="ml-15 mt-15" v-for="item in monthData">{{item.status_text}}份数：{{item.total_count}}</p>
        </div>
        <div class="px-15" v-else>
          <div class="flex justify-center mt-15 text-bold">
            暂无数据
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  dashboardMonthReport,
  dashboardUserReport,
  dashboardRecentReport,
} from "@/request/api";
import util from "@/utils/util";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      month: null,
      monthFormat: 'YYYY-MM',
      monthData: {},
      userData: {},
      recentData: []
    }
  },

  computed: {},
  watch: {},
  methods: {
    moment,
    userReport(){
      dashboardUserReport({}).then(res=>{
        this.userData = res.data.result
      })
    },
    monthReport(){
      dashboardMonthReport({ym: this.month}).then(res=>{
        this.monthData = res.data.result
      })
    },
    recentReport(){
      dashboardRecentReport({ym: this.month}).then(res=>{
        this.recentData = res.data.result
      })
    },
    changeMonth(d){
      this.monthReport();
    },
    toUserApply(){
      this.$router.push({
        path:'/PersonInfoManage',
        query: { type: 2 }
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  async created() {
    this.month =  moment().format("YYYY-MM");
    this.userReport();
    this.monthReport();
    this.recentReport();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {
    window.removeEventListener("resize", this.setBoxsWHFn);
  }, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg-main{
  background-color: rgba(255,255,255,0.7);
}
.inline-help{
  display: inline-block;
  width:16px;
  height:16px;
  line-height:16px;
  background-color:#555;
  color:#fff;
  text-align:center;
  border-radius:8px;
  cursor:pointer;
  margin-left: 5px;
}

.container_img {
  background-image: url("https://stjx.oss-cn-shenzhen.aliyuncs.com/business/other/web_image.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
}
table tr th{padding:5px 10px;border-left:1px solid #f6f6f6;}
table tr td{padding:5px 10px;border-left:1px solid #f6f6f6;}
table tr th:first-child{border-left:none;}
table tr td:first-child{border-left:none;}
.link-btn{
  color:rgb(26, 78, 210);
  cursor: pointer;
}
</style>